import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import useChannelDetails from 'hooks/useChannelDetails';
import {
  addContentTextToContent,
  addDltIdToContent,
  addEmailBccToContent,
  addEmailCcToContent,
  addLanguageToContent,
  addMediaLinkToContent,
  addSenderIdToContent,
  deleteContentById,
  deleteLanguageAndContentByIndex,
  onFromAddressChange,
  onFromNameChange,
  onSubjectChange,
  onToolIdChange,
  selectContentIndex,
  selectLanguagesForDropDown,
  selectSelectedContentIndex,
  selectTemplateContents,
  shouldEnableContent,
} from 'redux/content/content.slice';

import ContentAccordion from './ContentAccordion';

export type ContentAccordionProps = {
  edit?: boolean;
};
export const ContentAccordions: React.FC<ContentAccordionProps> = ({
  edit = false,
}) => {
  const { channel } = useChannelDetails();
  const nav = useNavigate();

  const templateContents = useSelector(selectTemplateContents);
  const selectedContentIndex = useSelector(selectSelectedContentIndex);
  const dropdownLanguages = useSelector(selectLanguagesForDropDown);
  // const shouldEnableAddContentButton = useSelector(
  //   selectShouldEnableAddContentButton
  // );
  const dispatch = useDispatch();
  if (!channel) return null;

  return (
    <div
      className="flex flex-col gap-4 h-full"
      style={{ height: '100%', overflow: 'auto' }}
    >
      {templateContents?.map((contentData, index) => (
        <div
          className={`${
            !shouldEnableContent(contentData, channel) &&
            index !== selectedContentIndex
              ? ' border-2 border-red-300 rounded-lg shadow-md'
              : ''
          }`}
        >
          <ContentAccordion
            key={index}
            channel={channel}
            edit={edit}
            onDelete={({ hasId }) => {
              if (hasId) {
                if (contentData.id) {
                  const deleteContentByIdCallBack = () => {
                    if (templateContents.length === 1) {
                      nav(`/content/channels/${channel}/overview`);
                    }
                  };
                  dispatch(
                    deleteContentById({
                      id: contentData.id,
                      channel,
                      deleteContentByIdCallBack,
                    })
                  );
                  return;
                }
              }
              dispatch(
                deleteLanguageAndContentByIndex({
                  selectedContentIndex: index,
                })
              );
            }}
            languages={dropdownLanguages}
            contentData={contentData}
            onLanguageSelect={(data: string) =>
              dispatch(
                addLanguageToContent({ language: data, contentIndex: index })
              )
            }
            onChangeContent={(data: string) => {
              dispatch(
                addContentTextToContent({
                  contentText: data,
                  contentIndex: index,
                  channel,
                })
              );
            }}
            onDltIdSelect={(data: string) =>
              dispatch(addDltIdToContent({ dltId: data, contentIndex: index }))
            }
            onSenderIdChange={(data: string) =>
              dispatch(
                addSenderIdToContent({ senderId: data, contentIndex: index })
              )
            }
            onMediaLinkChange={(data: string) =>
              dispatch(
                addMediaLinkToContent({ mediaLink: data, contentIndex: index })
              )
            }
            onEmailBccChange={(data: string) =>
              dispatch(
                addEmailBccToContent({ emailBcc: data, contentIndex: index })
              )
            }
            onEmailCcChange={(data: string) =>
              dispatch(
                addEmailCcToContent({ emailCc: data, contentIndex: index })
              )
            }
            index={index}
            selectedContentIndex={selectedContentIndex}
            onClick={() => {
              dispatch(selectContentIndex({ selectedContentIndex: index }));
            }}
            onToolIdChange={(toolId: string) => {
              dispatch(
                onToolIdChange({
                  toolId,
                  contentIndex: index,
                })
              );
            }}
            onFromNameChange={(fromName: string) => {
              dispatch(
                onFromNameChange({
                  fromName,
                  contentIndex: index,
                })
              );
            }}
            onFromAddressChange={(fromAddress: string) => {
              dispatch(
                onFromAddressChange({
                  fromAddress,
                  contentIndex: index,
                })
              );
            }}
            onSubjectChange={(subject: string) => {
              dispatch(
                onSubjectChange({
                  subject,
                  contentIndex: index,
                })
              );
            }}
          />
        </div>
      ))}
    </div>
  );
};
